// import moment from 'moment'
import { monthShortNames } from "../common/dates"
import dayjs from "dayjs"

// Returns number string with x decimal places
export function fixed (value:any, decimals?:any) {
  if (typeof value === 'number' && value !== null && value % 1 !== 0 && value !== undefined && !(isNaN(value))) {
    return decimals !== undefined ? parseFloat(value.toFixed(decimals)) : parseFloat(value.toFixed(2))
  }
  return value
}

// Rounds number to x precisions
export function roundToPrecision (value:any, precision?:number) {
  let y = value + (precision === undefined ? 0.5 : precision / 2)
  return y - (y % (precision === undefined ? 1 : precision))
}

// Adds $ symbol to + / - number strings
export function money (value:any) {
  if (value < 0) {
    let newValue = value.toString().substr(1, value.length)
    return '-$' + newValue
  }
  return '$' + value
}

// Adds % symbol to number string
export function percentage (value:any) {
  if (value) {
    return value + '%'
  }
}

// Converts to sentence case
export function sentenceCase (value:any) {
  value = value.replace(/([A-Z])/g, ' $1')
  let sentenceCase = value.charAt(0).toUpperCase() + value.slice(1)
  return sentenceCase
}

// Formats dates
export function formatDate (value:any, format?:string) {
  if (format) {
    return dayjs(value).format(format)
  }
  return value
}

// Convert date to YYYY-MM-DDTHH:mm:ss.sss for browser compatibility
export function cleanDate (value:any, format:string) {
  let date:any = new Date();
  let day:number = date.getDate();
  let month:number = date.getMonth();
  let year:number = date.getFullYear();
  let clean_date: Date = date;

  switch (format) {
    case 'D MMM':
      date = value.split(" ")
      year = new Date().getFullYear()
      month = monthShortNames.indexOf(date[1].toString())
      day = parseInt(date[0])
      clean_date = new Date(year, month, day)
      break;
    case 'DD/MM/YYYY':
      date = value.split("/")
      year = parseInt(date[3])
      month = parseInt(date[1]) - 1
      day = parseInt(date[0])
      clean_date = new Date(year, month, day)
      break;
    case 'YYYY-MM-DD':
      date = value.split("-")
      year = parseInt(date[0])
      month = parseInt(date[1]) - 1
      day = parseInt(date[3])
      clean_date = new Date(year, month, day)
      break;
    default:
      break;
  }

  return clean_date
}
